import moment from 'moment';
import { joinFormatted } from '../../../../utils/arrayExtensions';
import { isNumberUndefinedOrNull } from '../../../../utils/numberExtensions';
import { isNullOrWhitespace } from '../../../../utils/stringExtensions';
import { PERFORMANCE_METRIC_STATUSES } from '../../../shared/constants/checkpoint-performance-report-metric-enums';
import * as MetricTitles from '../constants/performanceMetricsTableColumnTitles';

export const isDateValid = (date, minDate, maxDate) => {
  return !(!date || moment(date).isBefore(minDate, 'day') || moment(date).isAfter(maxDate, 'day'));
};

export const isMetricsValid = metrics => {
  const invalidMetrics = metrics.map(validateMetric).filter(metric => !!metric);
  if (!invalidMetrics.length) {
    return { isMetricsValid: true, invalidMetrics: invalidMetrics };
  }

  return { isMetricsValid: false, invalidMetrics: invalidMetrics };
};

const validateMetric = metric => {
  if (metric.status === PERFORMANCE_METRIC_STATUSES.NA.Id) {
    return;
  }

  if (
    metric.status === PERFORMANCE_METRIC_STATUSES.Skip.Id ||
    metric.status === PERFORMANCE_METRIC_STATUSES.Discontinue.Id
  ) {
    if (isNullOrWhitespace(metric.notes)) {
      return {
        tempId: metric.tempId,
        measurementName: metric.measurementName,
        errorMessages: [formatErrorMessage(metric.measurementName, [MetricTitles.Notes])],
        invalidFields: [MetricTitles.Notes]
      };
    }
  }

  if (metric.status === PERFORMANCE_METRIC_STATUSES.Update.Id) {
    return validateMetricsForUpdateStatus(metric);
  }
};

const validateMetricsForUpdateStatus = metric => {
  const invalidFields = [];
  const errorMessages = [];

  if (isNumberUndefinedOrNull(metric.upperLimit) && isNumberUndefinedOrNull(metric.lowerLimit)) {
    if (isNumberUndefinedOrNull(metric.upperLimit)) {
      invalidFields.push(MetricTitles.UpperLimit);
    }
    if (isNumberUndefinedOrNull(metric.lowerLimit)) {
      invalidFields.push(MetricTitles.LowerLimit);
    }
  }

  if (!(isNumberUndefinedOrNull(metric.upperLimit) || isNumberUndefinedOrNull(metric.lowerLimit))) {
    if (metric.lowerLimit > metric.upperLimit) {
      invalidFields.push(MetricTitles.UpperLimit);
      invalidFields.push(MetricTitles.LowerLimit);
      errorMessages.push(
        `${metric.measurementName} - Upper limit cannot be less than the lower limit.`
      );
    }
  }

  if (isNumberUndefinedOrNull(metric.actual)) {
    invalidFields.push(MetricTitles.Actual);
  }

  if (isNullOrWhitespace(metric.notes)) {
    invalidFields.push(MetricTitles.Notes);
  }

  if (invalidFields.length > 0) {
    errorMessages.push(formatErrorMessage(metric.measurementName, invalidFields));

    return {
      tempId: metric.tempId,
      measurementName: metric.measurementName,
      invalidFields: invalidFields,
      errorMessages: errorMessages
    };
  }
};

const formatErrorMessage = (measurementName, invalidFields) => {
  return `${measurementName} - Enter ${
    invalidFields.length > 1 ? 'valid values' : 'a valid value'
  } for ${joinFormatted(invalidFields)} or change Status.`;
};
